"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBooleanToggle = void 0;
var react_1 = require("react");
function useBooleanToggle(initial) {
    var _a = __read((0, react_1.useState)(initial), 2), v = _a[0], setV = _a[1];
    function toggleOrSet(value) {
        if (typeof value === 'boolean') {
            setV(value);
        }
        else {
            setV(function (previous) { return !previous; });
        }
    }
    return [v, toggleOrSet];
}
exports.useBooleanToggle = useBooleanToggle;
